
export default {
  // 导入缩小框子
  name: 'XrImport',
  components: {},
  props: {
    // wait / process / finish / error / success
    processStatus: {
      type: String,
      default: 'wait'
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    loading: function loading() {
      return this.processStatus == 'process';
    },
    processLabel: function processLabel() {
      return this.loading ? '导入中' : '导入完成';
    }
  },
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {}
};